import PropTypes from 'prop-types'
import React from 'react'
import { Button, Tooltip } from 'antd'

import css from './Dashboard.css'

const LoginToPractice = ({
  loginToPractice,
  editPractice,
}) => ([
  <Tooltip
    key="login"
    title="Login to this practice with your login credentials"
    placement="topLeft"
    mouseEnterDelay="0.5"
    arrowPointAtCenter
  >
    <Button
      icon="login"
      className={css.editButton}
      onClick={loginToPractice}
    />
  </Tooltip>,
  <Tooltip
    key="edit"
    title="Edit this practice"
    placement="topLeft"
    mouseEnterDelay="0.5"
    arrowPointAtCenter
  >
    <Button
      icon="edit"
      className={css.editButton}
      onClick={editPractice}
    />
  </Tooltip>,
])

LoginToPractice.propTypes = {
  loginToPractice: PropTypes.func.isRequired,
  editPractice: PropTypes.func.isRequired,
}

export default LoginToPractice



// WEBPACK FOOTER //
// ./src/Dashboard/LoginToPractice.js